import { BubbleItem } from '@app/types/shop-bff/types';
import Box from '@redbubble/design-system/src/Box';
import Card from '@redbubble/design-system/src/Card';
import * as constants from '@redbubble/design-system/src/constants';
import Image from '@redbubble/design-system/src/Image';
import Text from '@redbubble/design-system/src/Text';
import styles from './TopicsSection.module.scss';

interface TopicImageCardProps {
  topic: BubbleItem;
}

export const TopicImageCard: React.FC<TopicImageCardProps> = ({ topic }) => {
  return (
    <Card
      className={styles.topicCard}
      onClick={() => {
        window.location.assign(topic.url);
      }}
      data-testid="topic-card"
    >
      <Box className={styles.imageContainer}>
        {topic.realisticImage ? (
          <Image
            className={styles.oppositeFluid}
            src={topic.realisticImage}
            alt=""
          />
        ) : (
          <Image
            size={constants.SMALL}
            src={topic.image}
            alt=""
            ratio={{
              type: constants.RATIO_SQUARE,
              mode: constants.RATIO_CONTAIN,
            }}
          />
        )}
      </Box>
      <Box className={styles.cardTitle}>
        <Text
          className={styles.dynamicText}
          textAlign={constants.CENTER}
          type="display6"
        >
          {topic.title}
        </Text>
      </Box>
    </Card>
  );
};
